import { Stack, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import CreditCardAliasBox from './Elements/CreditCardAliasBox'
import { useEffect } from 'react'
import { storeElement } from 'GlobalStores/StoreElement'
import { storeElement as storeElementUserAccount } from 'GlobalStores/Cores/Elements/StoreElement'
import CardFrontDrop from 'Components/Elements/CardFrontDrop/CardFrontDrop'
import styled from '@emotion/styled'
import { useCreditcardAliases } from './Hooks/useCreditcardAliases'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'

const SavedCreditCard = observer(() => {
    const translate = useTranslate()
    const { savedCreditCards, loading, fetchSavedCreditCards } = useCreditcardAliases()

    useEffect(() => {
        fetchSavedCreditCards()
        storeElementUserAccount.cardTitle.titleStep1 = <T>payment_methods</T>
    }, [])

    useEffect(() => {
        if (!loading) {
            storeElement.showCardFrontDrop = false
        } else if (loading) {
            storeElement.showCardFrontDrop = true
        }
    }, [loading])

    const afterAction = async () => {
        await fetchSavedCreditCards()
    }

    return (
        <StackMobileLayout
            padding={{
                xs: '32px 24px',
                md: '40px'
            }}
            gap="40px"
            height={'100%'}
            position={'relative'}>
            <Typography variant="h2" fontSize={'32px'} color="#003B6F" fontWeight={'700'} display={{ xs: 'none', md: 'block' }}>
                {translate('payment_methods')}
            </Typography>
            {loading || storeElement.showCardFrontDrop ? (
                <CardFrontDrop showLoader={true} box="pre-summary" />
            ) : (
                <CreditCardAliasBox savedCreditCards={savedCreditCards} afterAction={afterAction} />
            )}
        </StackMobileLayout>
    )
})

const StackMobileLayout = styled(Stack)`
    background-color: #ffffff;
    border-radius: 12px;
    height: 100%;
    min-height: calc(100vh - (74px + 64px));
    box-sizing: border-box;
`

export default SavedCreditCard
